<template>
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
            rounded
            color="primary"
            absolute
            dark
            small
            bottom
            right
            v-on = "on"
            @click="like(imageID)"
        >
            {{ likes > 0 ? likes : ''}}
            <v-icon>favorite</v-icon>
        </v-btn>
      </template>
      <span v-if="$store.state.loggedIn">Click to like this photo</span>
      <span v-if="!$store.state.loggedIn">You must be signed in to like this photo</span>
    </v-tooltip>
</template>

<script>
import axios from 'axios'
import { TokenService } from '@/services/storage.service'

export default {
  name: 'LikePhoto',
  components: {
  },
  props: {
    imageID: Number,
    likes: Number
  },
  methods: {
    like (id) {
      axios({ method: 'POST',
        'url': process.env.VUE_APP_WEBSITE + '/memberlogin2/api_like.php',
        params: {
          'Username': TokenService.getUsername(),
          'token': TokenService.getToken(),
          'imageID': id
        }}).then(result => {
            this.$store.state.meetingInfo.randomGalleryLikes += result.data.likeIncrement
            this.$store.commit('setMeetingInfo', this.$store.state.meetingInfo)
        }, error => {
        })
    }
  }
}
</script>
